import { CssBaseline, ThemeProvider } from '@mui/material';
import { legacyTheme } from '@siloreal:app:config/init/mui-config';
import { PropsWithChildren } from 'react';

export function OldMuiProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider theme={legacyTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
